import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <TopicsSection />
        <AboutSection />
        <CardsSection />
        <IndexSection />
        <MediaSection />
        <FaqSection />
        <AppSection />
        <UpdatesSection />
        <FeaturesSection />
        <ContactSection />
        <CarouselSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}